import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModalAtom from "../../../components/atoms/modal/modal";
import { selectProjectDetails } from "../../../store/slices/projectDetailsSlice";
import { useUpdateLVMutation } from "../../../store/services/lvService";
import { showToast } from "../../../utils/method";
import AddLVForm from "./add-lv-form";

const EditLVModal = ({
    show,
    onHide,
    projectId,
    lvData,
    onSuccess,
    isLocalProject = false,
}) => {
    const { t } = useTranslation();
    const [updateLV] = useUpdateLVMutation();

    const projectDetails = useSelector(selectProjectDetails);
    const currentProjectId = projectId || projectDetails?.id;

    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);

    const handleSubmit = async (formData) => {
        try {
            setLoading(true);
            const payload = {
                name: formData.get("name"),
                projectTicketCategoryId: formData.get("projectTicketCategoryId"),
                statusCode: formData.get("statusCode"),
                cost: formData.get("cost"),
            };
            const response = await updateLV({
                projectId: currentProjectId,
                lvId: lvData.id,
                ...payload,
            }).unwrap();
            if (onSuccess) onSuccess(response);
            showToast(t("lv.edit-success"), { type: "success" });
            onHide();
        } catch (error) {
            showToast(error || t("errors.general"), { type: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalAtom
            title={t("lv.edit-lv")}
            body={
                <AddLVForm
                    ref={formRef}
                    projectId={currentProjectId}
                    onSubmit={handleSubmit}
                    loading={loading}
                    mode="edit"
                    initialData={lvData}
                    onCancel={onHide}
                    isLocalProject={isLocalProject}
                    hideButtons
                />
            }
            show={show}
            handleClose={onHide}
            handleSubmit={() => formRef.current?.triggerSubmit()}
            saveText="common.update"
            disabled={loading}
            size="lg"
            backdrop="static"
        />
    );
};

export default EditLVModal;
